import { AppointmentType } from 'kb-shared';

export const isHomeMarketBookingRequired = (appointmentType: AppointmentType | undefined) =>
  Boolean(
    (appointmentType && !appointmentType.virtual && appointmentType.requireHomeMarket) ||
      (appointmentType?.inClinicOrVirtualEquivalent &&
        !appointmentType.inClinicOrVirtualEquivalent.virtual &&
        appointmentType.inClinicOrVirtualEquivalent.requireHomeMarket)
  );
